<!-- On vérifie que le rootForm existe avant de créer les champs liés -->
<div *ngIf="rootForm && juridictions && ! (modeRenduService.enModeImpression$ | async)">
  <div class="form-row mx-2 pb-3" *ngIf="rootForm && juridictions">
    <div class="col" [formGroup]="rootForm">
      <button *ngIf="modeRenduService.enModeSaisie$ | async" class="ml-n1 btn btn-info"
        (click)="ajouterJuridiction()">Ajouter un TJ/TPI/TPRX
      </button>
      <div class="col-md-12 ml-n4 mt-4">
        <bis-integer-inline-input [rootForm]="formulaire" label="xxTjNb" [max]="99" enLectureSeule="true"
          infoBulle="Cette zone est calculée automatiquement à partir du nombre de TJ/TPI/TPRX ajouté(s)">
        </bis-integer-inline-input>
        <bis-affiche-alertes labelAlerte='alertDg1'></bis-affiche-alertes>
        <bis-affiche-alertes labelAlerte='alertDg2'></bis-affiche-alertes>
      </div>
      <div>
        <div class="pt-3 mb-n3"> 
          <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
            labelErreur="ctrlDg4">
          </bis-affiche-erreurs-croisees>
        </div>  
        <mat-accordion class=" col-12">
          <div *ngFor="let item of juridictions.controls; let i = index">
            <mat-expansion-panel [expanded]="step === i" (opened)="setStep(i)">
              <mat-expansion-panel-header>
                <mat-panel-description>
                  <mat-icon>account_circle</mat-icon>&#xA0;
                  <span [ngClass]="{'onglet-invalide': juridictions.controls[i].invalid}">
                    Informations sur le TJ/TPI/TPRX {{ i + 1 }}
                    <!--<span *ngIf="juridictions.controls[i].get('xxTjIelst').value">
                      : {{ juridictions.controls[i].get('xxTjIelst').value }}
                    </span>-->
                  </span>
                  <button *ngIf="(modeRenduService.enModeSaisie$ | async)" (click)="supprimerJuridiction(i)" class="btn-danger btn-sm ml-auto"
                    title="Supprimer le TJ/TPI/TPRX">
                    <i class="material-icons md-18">delete</i>
                  </button>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="form-row">
                <div class="col-md-10">
                    <bis-filtered-select-input-keypad [preId]="i" [rootForm]="juridictions.controls[i]" nbChoixVisiblePossible="5" label="xxTjIelst" 
                          nomNomenclature="ielstTjTprx" [montreCode]="false" [erreursCroisees]="['ctrlDg4']">
                    </bis-filtered-select-input-keypad>
                  </div>
              </div>
              <div *ngIf="xxTjIelst(i) === ''">
                <br><br><br><br><br><br>
              </div>
            </mat-expansion-panel>
          </div>
        </mat-accordion>
      </div>
    </div>
  </div>
</div>


<!-- Partie pour l'impression comme boucle! -->
<!-- Remarque : les alertes et controles ne s'affichent pas en impression! -->
<div *ngIf="rootForm && juridictions && (modeRenduService.enModeImpression$ | async)">
  <div class="form-row mx-2 pb-3" *ngIf="rootForm && juridictions">
    <div class="col" [formGroup]="rootForm">
      <div class="col-md-12 ml-n4 mt-4">
        <bis-integer-inline-input [rootForm]="formulaire" label="xxTjNb" [max]="99" enLectureSeule="true"
          infoBulle="Cette zone est calculée automatiquement à partir du nombre de TJ/TPI/TPRX ajouté(s)">
        </bis-integer-inline-input>
        <bis-affiche-alertes labelAlerte='alertDg1'></bis-affiche-alertes>
        <bis-affiche-alertes labelAlerte='alertDg2'></bis-affiche-alertes>
      </div>
      <div>
          <div class="pt-3 mb-n3"> 
            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
              labelErreur="ctrlDg4">
            </bis-affiche-erreurs-croisees>
          </div>  
          <div *ngFor="let item of juridictions.controls; let i = index">
            <div class="form-row">
                <div class="col-md-10">
                  <bis-filtered-select-input-keypad [preId]="i" [rootForm]="juridictions.controls[i]" nbChoixVisiblePossible="5" 
                        label="xxTjIelst" libelle="vide" nomNomenclature="ielstTjTprx" [montreCode]="false" [erreursCroisees]="['ctrlDg4']">
                  </bis-filtered-select-input-keypad>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>